<template>
  <div class="d-flex flex-column h-100">
    <!-- Header with Settings Icon and Title -->
    <header class="header bg-bb5-yellow p-3 pt-1 pb-2 d-flex align-items-center justify-content-between">
      <h1 class="m-0"><RouterLink to="/">#playeverwhere</RouterLink></h1>

      <!-- Settings Dropdown -->
      <div class="dropdown">
        <button
            class="btn"
            type="button"
            id="settingsDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
        >
          <i class="fas fa-ellipsis-v text-bb5-black"></i> <!-- Font Awesome Settings Icon -->
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="settingsDropdown">
          <li><a class="dropdown-item" href="#" @click="resetGame">Reset Game</a></li>
          <li><a class="dropdown-item" href="#" @click="savedGame">Saved Games</a></li>
<!--          <li><a class="dropdown-item" href="#" @click="goToAccount">Account</a></li>-->
          <li><router-link class="dropdown-item" to="/settings" >Settings</router-link></li>
          <li><router-link class="dropdown-item" to="/players" >My players</router-link></li>
          <li><a class="dropdown-item" @click="$store.commit('TOOGLE_GAME_VIEW')" >Game View</a></li>
          <li><router-link class="dropdown-item" to="/info" >Info</router-link></li>
<!--          <li><a class="dropdown-item" href="#" @click="showInfo">Info</a></li>-->
          <li><a class="dropdown-item" href="#" @click="logout">Logout</a></li>
        </ul>
      </div>
    </header>

    <!-- Main Content -->
    <div class="main">
      <router-view />
    </div>
    <footer class="footer mt-auto border-top align-items-center small text-secondary p-1 text-center">
      <div>© {{ new Date().getFullYear() }} Niels Gongoll V1.0.1</div>
    </footer>
  </div>
</template>


<script>
import authService from './services/authService';
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
  name: "App",
  created() {
    // this.$store.dispatch('loadLocalSettings');
    authService.isAuthenticated();
  },
  computed: {
    ...mapState(['teams']),
    ...mapGetters(['gameIsRunning', 'step']),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    ...mapActions(['setGameIsRunning']),
    handleTeamsSubmit(teams) {
      this.teams = teams;
    },
    resetGame() {
      // Logic to reset the game
      this.setGameIsRunning(false);
      localStorage.removeItem('currentgame');
      this.$router.push('/'); // Zu Login (Home)

    },
    savedGame() {
      this.$router.push('/gameselection');
    },
    goToAccount() {
      // Logic to navigate to the account section
      alert("Go to Account!");
    },
    showInfo() {
      // Logic to show info modal or information
      alert("Game Info!");
    },
    logout() {
      this.$store.dispatch('setIsLoggedIn', false);
      authService.logout();
      this.$router.push('/'); // Nach Logout zurück
    },
    navigateToGameTypeSelection() {
      this.$router.push('/game-type-selection'); // Seite "Spieltypen-Auswahl"
    },

  },
};
</script>

<style>
:root {
  --bb5-yellow: #FFDA00;
  --bb5-black: #5c5750;
  --bs-btn-hover-color: #ffffff;
  --bs-link-color-rgb: #212529!important;
}

/* Define the font face */
@font-face {
  font-family: 'Klavika-Regular'; /* Name of the font */
  src: url('assets/fonts/KlavikaBasic-Regular.otf') format('opentype'); /* Path to your font file and format */
  font-weight: normal; /* Specify font weight */
  font-style: normal; /* Specify font style */
}

@font-face {
  font-family: 'Hatten'; /* Name of the font */
  src: url('assets/fonts/HATTEN.TTF') format('truetype'); /* Path to your font file and format */
  font-weight: normal; /* Specify font weight */
  font-style: normal; /* Specify font style */
}

/* Use the font in your styles */
body {
  font-family: 'Klavika-Regular', sans-serif;
}
.main {
  height: 90%;
  overflow: scroll;
}
a {
  color: var(--bs-link-color-rgb)!important;
  text-decoration: none!important;
}
.bg-bb5-yellow {
  background-color: var(--bb5-yellow) !important;
  color: var(--bb5-black) !important;
}

.text-bb5-yellow {
  color: var(--bb5-yellow) !important;
}

.btn-danger {
  background-color: #ff4d4d;
  color: white;
  border: none;
}
.btn-danger:hover {
  background-color: #ff1a1a;
}


.text-bb5-black {
  color: var(--bb5-black) !important;
}

.btn-bb5-yellow, .add-button, .add-to-homescreen-visible button {
  background-color: var(--bb5-yellow) !important;
  border-color: var(--bb5-yellow) !important;
  color: var(--bb5-black) !important;
}

.btn-bb5-yellow:hover,
.btn-bb5-yellow:focus {
  background-color: #e6c200 !important; /* Darken on hover */
  border-color: #e6c200 !important;

}

.btn-bb5-black {
  background-color: var(--bb5-black) !important;
  border-color: var(--bb5-black) !important;
  color: #ffffff !important;
}

.btn-bb5-black:hover,
.btn-bb5-black:focus {
  background-color: #33312CFF !important; /* Darken on hover */
  border-color: #33312CFF !important;
  color: #ffffff !important;
}

/* New btn-outline-bb5 class for outline buttons */
.btn-outline-bb5 {
  background-color: transparent !important;
  color: var(--bb5-black) !important;
  border-color: var(--bb5-yellow) !important;
}

.btn-outline-bb5:hover,
.btn-outline-bb5:focus {
  background-color: var(--bb5-yellow) !important;
  color: var(--bb5-black) !important;
  border-color: var(--bb5-yellow) !important;
}

/* Active/selected state for outline button */
.btn-outline-bb5.active,
.btn-outline-bb5:active {
  background-color: var(--bb5-yellow) !important;
  color: var(--bb5-black) !important;
  border-color: var(--bb5-yellow) !important;
}

.add-button, .add-to-homescreen-visible button {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x) !important;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Adjusted to put the settings icon on the right */
  background-color: var(--bb5-yellow);
  padding: 15px;
}
.footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.btn-outline-bb5 {
  background-color: transparent !important;
  color: var(--bb5-black) !important;
  border-color: var(--bb5-black) !important;
}

.btn-outline-bb5:hover {
  background-color: var(--bb5-black) !important;
  color: white !important;
}

.dropdown-menu-end {
  right: 0;
  left: auto;
}

.fas {
  font-size: 1.5em;
}

/* Heading Style */
h1 {
  font-size: 24px;
  color: black;
  text-transform: lowercase;
  margin: 0;
  font-family: Hatten;
}

h2 {
}

h2, h3 {
  font-family: Hatten;
}

label {
  text-transform: uppercase;
}

input {
  background: var(--bb5-yellow);
  border: none;
}

/**
 * Remove focus styles for non-keyboard focus.
 */
:focus:not(:focus-visible) {
  outline: 0;
  box-shadow: none;
}

/**
 * Cross-browser styles for explicit focus via
 * keyboard-based (eg Tab) navigation or the
 * .focus-visible utility class.
 */
:focus,
.focus-visible:focus:not(:focus-visible) {
  outline: 0;
  box-shadow: 0 0 0 .2rem #fff,
  0 0 0 .35rem #069;
}

/**
 * Remove focus styles for non-keyboard focus.
 */
:focus:not(:focus-visible) {
  outline: 0;
  box-shadow: none;
}

/**
 * Cross-browser styles for explicit focus via
 * keyboard-based (eg Tab) navigation or the
 * .focus-visible utility class.
 */
:focus,
.focus-visible:focus:not(:focus-visible) {
  outline: 0;
  box-shadow: 0 0 0 .2rem #fff,
  0 0 0 .35rem #069;
}

@include media-breakpoint-up(md) {
  .btn-group-lg > .btn, .btn-xl {
    --bs-btn-padding-y: 1.5rem;
    --bs-btn-padding-x: 3rem;
    --bs-btn-font-size: 3.25rem;
    --bs-btn-border-radius: var(--bs-border-radius-lg);
  }
}
.btn-group-lg > .btn, .btn-xl {
  --bs-btn-padding-y: 1.5rem;
  --bs-btn-padding-x: 3rem;
  --bs-btn-font-size: 3.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}
</style>
